/* eslint-disable  */
// eslint-disable-next-line react-hooks/exhaustive-deps

import React, { useMemo, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {
    Button, Grid, Typography, IconButton, Tooltip, DialogTitle,
    Dialog, DialogContent, Menu, MenuItem
} from '@material-ui/core';
import { DataGrid } from '@mui/x-data-grid';
import { MoreVert } from '@material-ui/icons';
import { useDepartment } from '~/departments';
import { useEmployees, useUpdateEmployee } from '~/employees';
import AssignEmployeeForm from './AssignEmployeeForm';
import Form from '../employees/Form';


const useStyles = makeStyles({
    dataGrid: {
        '&.MuiDataGrid-root .MuiDataGrid-columnHeader:focus, &.MuiDataGrid-root .MuiDataGrid-cell:focus': {
            outline: 'none'
        }
    },
    tableWrapper: {
        width: '100%'
    },
    redButton: {
        color: '#fff',
        backgroundColor: '#DB2828'
    }
});



const DeptEmployees = (props) => {


    //specific department data passed through the url
    const department_id = props.match.params.department_id


    //Department Data
    const { data: department, isLoading } = useDepartment(department_id);

    //Bringing department name to tittle based on the department id
    const department_name = department?.name


    //Dialog state for "Assign" button 
    const [modalOpen, setModalOpen] = useState(false);

    //Dialog state for "Edit" button
    const [editModalOpen, setEditModalOpen] = useState(false);


    //Defining Styles
    const classes = useStyles();

    //Handle to open "Assign" dialog
    const handleClickOpen = () => {
        setModalOpen(true);
    }

   
    // console.log(props)
    // console.log('hallo')


    // use useEmployees to get all employees
    const { data: employees, isLoading: employeesisLoading, error } = useEmployees();
    const { mutate: updateEmployee } = useUpdateEmployee();

    // list of the employees that could be assign in a specific department
    //find employees ids of specific department
    const employeesIds = department?.employees.map(employee => employee.id)
    //filter employees to remove employeesIds employees from the list 
    const departmentEmployees = employees?.filter(employee => employeesIds?.includes(employee.id))
    const notDepartmentEmployees = employees?.filter(employee => !employeesIds?.includes(employee.id))
    const [rowSelected, setRowSelected] = useState();
    const [actions, setActions] = useState(null);


    // for Edit form 
    const [initialValues, setInitialValues] = useState(null);


    // Popover settings.
    const openPopover = (event, row) => {
        // console.log("????", row)
        setRowSelected(row)
        setActions(event.currentTarget);
    };
    const closePopover = () => {
        setActions(null);
    };
    const moreActions = Boolean(actions);

    //Submit
    const onAssignSubmit = (values) => {
        // console.log(values, 'hahaha')

        const dep = values.departments.map(dept => {

            return { id: dept.id };
        });
        {
            updateEmployee({
                id: values.id,
                payload: {
                    ...values,
                    departments: [...dep, {
                        id: department_id
                    }]
                }
            });
        }
    };

    const onEditSubmit = (values) => {
        // console.log(values, 'hahaha')

        const dep = values.departments.map(dept => {

            return { id: dept.id };
        });
        {
            updateEmployee({
                id: values.id,
                payload: {
                    ...values
                }
            });
        }
    };




    //setup for employees column
    const columns = useMemo(() => [


        {
            field: 'employees',
            renderHeader: () => <strong>Employees</strong>,
            renderCell: ({ row }) => {
                return <div>{row.name}</div>
            },
            flex: 1
        },
        //setup for actions column & adding a edit button to each row
        {
            field: 'Actions',
            align: 'right',
            headerAlign: 'right',
            renderHeader: () => <strong>Actions</strong>,
            renderCell: ({ row }) => (
                <div>
                    <IconButton onClick={(e) => openPopover(e, row)}>
                        <MoreVert />
                    </IconButton>
                </div>
            ),
            flex: .2
        }

    ], []);

    // console.log(initialValues)
    // console.log('what is form?')
    //Table
    return (

        <div>
            <Grid container justifyContent='space-between' style={{ marginBottom: '20px', marginTop: '20px' }}>
                <Grid item>
                    <Typography variant='h4' children={department_name} />
                </Grid>

                <Grid item>
                    <Button
                        children='Assign'
                        variant='contained'
                        color='primary'
                        onClick={handleClickOpen}
                    />
                    <Dialog>
                        <DialogTitle content={`Assign New Employee`} />

                    </Dialog>
                </Grid>
            </Grid>



            <DataGrid
                className={classes.dataGrid}
                //loading={isLoading}
                columns={columns}
                rows={departmentEmployees || []}
                autoHeight
                disableSelectionOnClick
                hideFooterSelectedRowCount
            />
            <Menu
                id='actions'
                open={moreActions}
                anchorEl={actions}
                onClose={closePopover}
                onClickCapture={closePopover}
            >
                <MenuItem
                    onClick={() => { 
                        // console.log('clickeeed')
                        setInitialValues(rowSelected);
                        setEditModalOpen(true);
                    }}
                    style={{
                        width: '120px'
                    }}>
                    Edit
                </MenuItem>
            </Menu>


            <Dialog open={modalOpen} onClose={() => setModalOpen(false)}>
                <DialogContent>
                    <AssignEmployeeForm setModalOpen={setModalOpen} employees={notDepartmentEmployees} onSubmit={onAssignSubmit} department_id={department_id} />
                </DialogContent>
            </Dialog>

            <Dialog open={editModalOpen} onClose={() => setEditModalOpen(false)}>
                <DialogContent>
                    <Form setModalOpen={setEditModalOpen} initialValues={initialValues} onSubmit={onEditSubmit}/>
                </DialogContent>
            </Dialog>

        </div>


    )
};

export default DeptEmployees;